import React, { useEffect, useState } from 'react';
import { Alert, Button, Card, Col, Form, Input, InputNumber, message, Modal, PageHeader, Row, Space, Table, Typography, Upload } from 'antd';
import { Provider } from 'jotai';
import { useModalRegistrarPuntos, usePuntosPage } from './hooks';
import { DebounceSelect } from 'components/DebounceSelect';
import { LoginService } from 'services/LoginService';
import { Headers, TipoUsuario } from 'enums';
import { ClearOutlined, FileExcelOutlined, SearchOutlined, UploadOutlined } from "@ant-design/icons"

const PuntosPage = () => {
    return (
        <Provider>
            <Navegacion />
            <Filtros />
            <StatusImportacion />
            <Card bordered={false}>
                <Botones />
                <ListaPuntos />
            </Card>
            <ModalRegistrarPuntos />
        </Provider>
    );
};

const Filtros = () => {

    const { fetchPuntos } = usePuntosPage();

    const [filters, setFilters] = useState({
        numeroDocumentoIdentidad: '',
        apellidoPaterno: '',
        apellidoMaterno: '',
        nombres: ''
    });

    const handleInputChange = (field, value) => {
        setFilters(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleSearch = () => {
        fetchPuntos(filters);
    };

    const handleClear = () => {
        const params = {
            numeroDocumentoIdentidad: '',
            apellidoPaterno: '',
            apellidoMaterno: '',
            nombres: ''
        }
        setFilters(params);
        fetchPuntos(params);
    };

    return (
        <Card
            bordered={false}
            style={{
                marginBottom: "10px"
            }}
        >
            <Row align="middle" gutter={[16, 16]}>
                <>
                    <Col xs={24} sm={8} md={5}>
                        <Space direction="vertical" style={{ width: '100%' }}>
                            <span style={{ fontWeight: 500 }}>DNI:</span>
                            <Input
                                placeholder="Ingrese valor"
                                value={filters.numeroDocumentoIdentidad}
                                onChange={(e) => handleInputChange('numeroDocumentoIdentidad', e.target.value)}
                                style={{ width: '100%' }}
                            />
                        </Space>
                    </Col>

                    <Col xs={24} sm={8} md={5}>
                        <Space direction="vertical" style={{ width: '100%' }}>
                            <span style={{ fontWeight: 500 }}>Apellido Paterno:</span>
                            <Input
                                placeholder="Ingrese valor"
                                value={filters.apellidoPaterno}
                                onChange={(e) => handleInputChange('apellidoPaterno', e.target.value)}
                                style={{ width: '100%' }}
                            />
                        </Space>
                    </Col>

                    <Col xs={24} sm={8} md={5}>
                        <Space direction="vertical" style={{ width: '100%' }}>
                            <span style={{ fontWeight: 500 }}>Apellido Materno:</span>
                            <Input
                                placeholder="Ingrese valor"
                                value={filters.apellidoMaterno}
                                onChange={(e) => handleInputChange('apellidoMaterno', e.target.value)}
                                style={{ width: '100%' }}
                            />
                        </Space>
                    </Col>

                    <Col xs={24} sm={8} md={5}>
                        <Space direction="vertical" style={{ width: '100%' }}>
                            <span style={{ fontWeight: 500 }}>Nombres:</span>
                            <Input
                                placeholder="Ingrese valor"
                                value={filters.nombres}
                                onChange={(e) => handleInputChange('nombres', e.target.value)}
                                style={{ width: '100%' }}
                            />
                        </Space>
                    </Col>

                    <Col xs={24} sm={24} md={4}>
                        <Space style={{ marginTop: '24px', float: 'right' }}>
                            <Button
                                onClick={handleClear}
                                icon={<ClearOutlined />}
                            >
                                Limpiar
                            </Button>
                            <Button
                                type="primary"
                                onClick={handleSearch}
                                icon={<SearchOutlined />}
                            >
                                Buscar
                            </Button>
                        </Space>
                    </Col>
                </>
            </Row>
        </Card>
    );
};

const StatusImportacion = () => {
    const { dnisNoProcesados } = usePuntosPage();

    if (dnisNoProcesados.length === 0) {
        return "";
    }

    return (
        <Alert
            message="Error"
            description={`Los siguientes DNIs no han sido procesados: ${dnisNoProcesados?.join(', ')}`}
            type="error"
            showIcon
            style={{ marginBottom: "10px" }}
        />
    )
}

const Botones = () => {

    const { fetchPuntos, exportar, loading: loadingExportar, setDnisNoProcesados } = usePuntosPage();
    const { abrirModal } = useModalRegistrarPuntos();
    const [loading, setLoading] = useState(false);

    const propsBtnImportarPuntosObtenidos = {
        name: "excel",
        action: process.env.REACT_APP_ENDPOINT + "admin/comunicaciones-cultura/puntos/importar/puntos-obtenidos",
        showUploadList: "false",
        headers: {
            ["authorization"]: "Bearer " + LoginService.getJwtToken(),
            [Headers.ORGANIZACION_ID]: LoginService.getUsuarioAutenticado().organizacionId,
            [Headers.EMPRESA_ID]: LoginService.getUsuarioAutenticado().empresaSeleccionada.id,
            [Headers.TIPO_USUARIO]: TipoUsuario.ADMIN
        },
        onChange(info) {
            if (info.file.status === 'uploading') {
                setLoading(true);
            }
            if (info.file.status !== 'uploading') {
                fetchPuntos();
                console.log(info.file, info.fileList);
            }
            if (info.file.status === 'done') {
                setDnisNoProcesados(info.file.response.dnisNoProcesados);
                if (info.file.response.dnisNoProcesados.length > 0) {
                    message.success(`Se subió los puntos con algunas observaciones`);
                } else {
                    message.success(`Se subió los puntos correctamente`);
                }

                setLoading(false);
            } else if (info.file.status === 'error') {
                message.error(`No se ha podido subir los puntos. Intente nuevamente.`);
                setLoading(false);
            }
        },
    };

    const propsBtnImportarPuntosCanjeados = {
        name: "excel",
        action: process.env.REACT_APP_ENDPOINT + "admin/comunicaciones-cultura/puntos/importar/puntos-canjeados",
        showUploadList: "false",
        headers: {
            ["authorization"]: "Bearer " + LoginService.getJwtToken(),
            [Headers.ORGANIZACION_ID]: LoginService.getUsuarioAutenticado().organizacionId,
            [Headers.EMPRESA_ID]: LoginService.getUsuarioAutenticado().empresaSeleccionada.id,
            [Headers.TIPO_USUARIO]: TipoUsuario.ADMIN
        },
        onChange(info) {
            if (info.file.status === 'uploading') {
                setLoading(true);
            }
            if (info.file.status !== 'uploading') {
                fetchPuntos();
                console.log(info.file, info.fileList);
            }
            if (info.file.status === 'done') {
                message.success(`Se subió los puntos correctamente`);
                setLoading(false);
            } else if (info.file.status === 'error') {
                message.error(`No se ha podido subir los puntos. Intente nuevamente.`);
                setLoading(false);
            }
        },
    };

    return (
        <Row justify="end" style={{ marginBottom: "10px" }}>
            <Space>
                <Button type='primary' onClick={abrirModal}>
                    + Crear Punto
                </Button>

                <Upload {...propsBtnImportarPuntosObtenidos} maxCount={1} itemRender={() => ("")}>
                    <Button icon={<UploadOutlined />} loading={loading}>
                        Subir Puntos Obtenidos
                    </Button>
                </Upload>

                <Upload {...propsBtnImportarPuntosCanjeados} maxCount={1} itemRender={() => ("")}>
                    <Button icon={<UploadOutlined />} loading={loading}>
                        Subir Puntos Canejados
                    </Button>
                </Upload>

                <Button onClick={exportar} loading={loadingExportar}>
                    <FileExcelOutlined /> Exportar
                </Button>
            </Space>
        </Row>
    )
}

const ListaPuntos = () => {

    const { puntos, fetchPuntos } = usePuntosPage();

    useEffect(() => {
        fetchPuntos();
    }, []);

    const columnas = [
        {
            title: "Colaborador",
            // width: '35%',
            render: (fila) =>
                <Row direction="vertical">
                    <Col span={24}>
                        <Typography.Text>
                            {fila.colaborador.apellidoPaterno} {fila.colaborador.apellidoMaterno} {fila.colaborador.nombres}
                        </Typography.Text>
                    </Col>
                    <Col span={24}>
                        <Typography.Text type='secondary'>
                            {fila.colaborador.numeroDocumentoIdentidad}
                        </Typography.Text>
                    </Col>
                </Row>
        },
        {
            title: "Año",
            dataIndex: "anio",
            width: '10%',
        },
        {
            title: "Semana",
            dataIndex: "semana",
            width: '10%',
        },
        {
            title: "Puntos Obtenidos",
            dataIndex: "puntosObtenidos",
            width: '10%',
        },
        {
            title: "Puntos Canjeados",
            dataIndex: "puntosCanjeados",
            width: '10%',
        },
        {
            title: "Saldo",
            dataIndex: "saldo",
            width: '10%',
        }
    ];

    return (
        <Table
            rowKey={(puntos) => puntos.id}
            dataSource={puntos}
            columns={columnas}
            size='small'
        />
    )
}


const Navegacion = () => {
    return (
        <PageHeader
            title="Puntos"
            breadcrumb={{
                routes: [
                    { breadcrumbName: "Comunicación y Cultura" },
                    { breadcrumbName: 'Puntos' }
                ],
            }}
            style={{ paddingLeft: "0px" }}
        />
    )
}

const ModalRegistrarPuntos = () => {

    const [form] = Form.useForm();
    const { open, colaboradores, setColaboradores, fetchColaboradores, cerrarModal, registrar } = useModalRegistrarPuntos();

    return (
        <Modal
            title="Registrar Puntos"
            open={open}
            onCancel={cerrarModal}
            // footer={null}
            onOk={() => { registrar(form) }}
            okText="Registrar Puntos"
            centered={true}
            destroyOnClose={true}
        >
            <Form form={form} layout="vertical">

                <Form.Item
                    label="Colaborador"
                    name="colaborador"
                    rules={[
                        { required: true, message: "Debe seleccionar un colaborador." },
                    ]}
                >
                    <DebounceSelect
                        showSearch
                        allowClear
                        value={colaboradores}
                        placeholder="Escribe el nombre del colaborador"
                        fetchOptions={fetchColaboradores}
                        onChange={(newValue) => {
                            setColaboradores(newValue);
                        }}
                        style={{
                            width: '100%',
                        }}
                    />
                </Form.Item>

                <Row>
                    <Col span={8}>
                        <Form.Item
                            label="Año"
                            name="anio"
                            rules={[
                                { required: true, message: "Campo obligatorio." },
                            ]}
                        >
                            <InputNumber />
                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item
                            label="Semana"
                            name="semana"
                            rules={[
                                { required: true, message: "Campo obligatorio." },
                            ]}
                        >
                            <InputNumber />
                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item
                            label="Puntos"
                            name="puntos"
                            rules={[
                                { required: true, message: "Campo obligatorio." },
                            ]}
                        >
                            <InputNumber />
                        </Form.Item>
                    </Col>

                </Row>

            </Form>
        </Modal>
    );
};

export default PuntosPage;